import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  width: 100%;
  background: #ffffff20;
  border-radius: 3px;
  height: 40px;
  align-items: center;
  padding-right: 10px;
`;

export const MicIcon = styled.img`
  border: 0;
  flex-shrink: 0;
  border-image-width: 0;
`;
